export default {

    title: 'Επιλογή ημερομηνίας',
    subtitle: 'Επίλεξε ημερομηνία για να δεις την καταγραφή',
    weekly: 'Προβολή εβδομάδας',
    comments: {
        title: 'Σημειώσεις - Σχόλια προς πελάτη',
        subtitle: 'Άφησε ένα σχόλιο στον πελάτη σου για την καταγραφή του στις {date}'
    },
    deleteConnection: 'Διαγραφή σύνδεσης με τον πελάτη',
    noEmail: {
        title: 'Ο πελάτης δεν έχει e-mail',
        subtitle: 'Πρόσθεσε το e-mail του για να συνδεθείς μαζί του μέσω της εφαρμογής athlisis.',
        placeholder: 'email@example.com',
        save: 'Αποθήκευση'
    },
    photos: 'Φωτογραφίες',
    notRegisteredUser: {
        title: 'Ο πελάτης σου δεν έχει εγγραφεί στην εφαρμογή',
        subtitle: 'Για να βλέπεις τις καταγραφές του, ο πελάτης πρέπει πρώτα να δημιουργήσει λογαριασμό στην εφαρμογή athlisis.',
        content: '<h2>Οδηγίες εγκατάστασης:</h2>\n' +
            '        <ol>\n' +
            '          <li>Λήψη της εφαρμογής athlisis από το <a ref="nofollow" href="https://play.google.com/store/apps/details?id=com.athlisis.athlisis" target="_blank">\n' +
            '            Google Play Store (κάνε κλικ ή αναζήτησε «athlisis»)</a> ή\n' +
            '            <a ref="nofollow" href="https://apps.apple.com/us/app/athlisis/id1551491052#?platform=iphone" target="_blank">\n' +
            '              App Store (κάνε κλικ ή αναζήτησε «athlisis»)\n' +
            '            </a>\n' +
            '            από τον πελάτη.\n' +
            '          </li>\n' +
            '          <li>Εγγραφή με το <strong>ίδιο e-mail</strong> που έχει δηλωθεί στην καρτέλα του πελάτη (τόνισέ του το).</li>\n' +
            '          <li>Αφότου έχει δημιουργηθεί ο λογαριασμός του πελάτη, μπορεί να συνδεθεί στην εφαρμογή.</li>\n' +
            '          <li>Εσύ μπορείς οποιαδήποτε στιγμή να πατήσεις «Αποστολή αίτησης σύνδεσης» σε αυτή τη σελίδα.</li>\n' +
            '          <li>Τέλος, αρκεί ο πελάτης να αποδεχτεί την αίτησή σου και θα μπορείς να βλέπεις τις καταγραφές του.</li>\n' +
            '        </ol>'
    },
    muted: {
        title: 'Δεν έχεις πρόσβαση στις καταγραφές του πελάτη',
        content: 'Ο πελάτης έχει απενεργοποιήσει την πρόσβασή σου στο ημερολόγιο καταγραφής του.'
    },
    request: {
        title: 'Κάνε αίτηση σύνδεσης με τον πελάτη σου',
        subtitle: 'Αν ο πελάτης σου έχει ήδη λογαριασμό στην εφαρμογή athlisis, στείλε του αίτηση σύνδεσης και περίμενε να την αποδεχτεί.',
        cta: 'Αποστολή αίτησης σύνδεσης'
    },
    pending: {
        title: 'Αναμονή έγκρισης πελάτη',
        subtitle: 'Η αίτησή σου για πρόσβαση στο ημερολόγιο καταγραφής έχει σταλεί στον πελάτη.'
    },
    hour: 'Ώρα',
    entriesLabel: 'Καταγραφές',
    commentPlaceholder: 'Προσθήκη σχολίου',
    goalPlaceholder: 'Πληκτρολόγησε τον στόχο...',
    autoShareWarning: 'Οι στόχοι αυτοί μοιράζονται αυτόματα στην εφαρμογή του πελάτη σου.',
    noReport: 'Χωρίς καταγραφή',
    noReportText: 'Ό,τι καταγράφει ο πελάτης στην εφαρμογή θα εμφανίζεται εδώ.',
}